import {
  ParagraphStyledComponentConstructor,
  TextStyledComponentConstructor,
} from '@zg-rentals/backend-styled-components';

const Source = ({ card = '', tip = '' }) => ({
  card: String(card),
  tip: String(tip),
});

const LearnMore = ({ title = {}, content = [] }) => {
  return {
    title: TextStyledComponentConstructor(title),
    content: content.map((c) => ParagraphStyledComponentConstructor(c)),
  };
};

const Rec = ({
  description = '',
  isComplete = null,
  isFree = null,
  action = '',
  type = '',
  outcome = '',
  icon = '',
  outcomeStats = null,
  source = {},
  learnMore = {},
}) => {
  return {
    description: String(description),
    isComplete: Boolean(isComplete),
    isFree: Boolean(isFree),
    action: String(action),
    type: String(type),
    outcome: String(outcome),
    icon: String(icon),
    outcomeStats: Number(outcomeStats),
    source: Source(source),
    learnMore: LearnMore(learnMore),
  };
};

const Completeness = ({ rating = '', score = null, leadImpact = null }) => ({
  rating: String(rating),
  score: Number(score),
  leadImpact: leadImpact ? Number(leadImpact) : null,
});

const ListingRecs = ({ recommendations = [], completeness = {} }) => ({
  completeness: Completeness(completeness),
  recommendations: recommendations.map((rec) => Rec(rec)),
});

export default ListingRecs;

export type ListingRecsProps = ReturnType<typeof ListingRecs>;
